import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Res, Permission, WhenPrint, DeliveryNoteDTO } from 'core/api';
import * as DeliveryNoteStore from './DeliveryNoteStore';
import { Message } from 'core/ui-next/modal';

async function shouldPrintDeliveryNote(): Promise<Result<boolean>> {

	const whenPrint = SessionProvider.getCurrent().DeliveryNoteWhenPrint;

	switch (whenPrint) {
		case WhenPrint.Always:
			return Result.ok(true);
		case WhenPrint.Never:
			return Result.ok(false);
		case WhenPrint.AskUser: {
			const { ok } = await Message.confirm(Res.Msg.MSG_ASK_TO_PRINT_DELIVERY_NOTE());
			return ok ? Result.ok(true) : Result.ok(false);
		}
		default:
			return Result.error();
	}

}

declare global {
	interface CommandType {
		cancelDeliveryNotes: (notes: DeliveryNoteDTO[]) => Promise<Result>
	}
}

Command.register('cancelDeliveryNotes', Preconditions.and(Preconditions.ensure(Permission.DeliveryNote_Cancel), Preconditions.ensureIsNotLite), async (notes: DeliveryNoteDTO[]): Promise<Result> => {
	if (notes.length === 0) {
		await Message.show(Res.Msg.MSG_DELIVERY_NOTES_TO_CANCEL_MUST_NOT_BE_EMPTY());
		return Result.error();
	} else if (!notes.every(x => x.PrepaidAmount === 0)) {
		await Message.show(Res.Msg.MSG_DELIVERY_NOTES_TO_CANCEL_CANNOT_HAVE_PREPAID_AMOUNT());
		return Result.error();
	}

	const { ok } = await Message.confirm(Res.Msg.MSG_CONFIRM_DELIVERY_NOTES_CANCELLATION(notes.length));
	if (!ok)
		return Result.ok();

	const shouldPrintResult = await shouldPrintDeliveryNote();
	if (shouldPrintResult.ok)
		await DeliveryNoteStore.cancel(notes.map(x => x.Id), shouldPrintResult.value);

	return Result.ok();
});

